export const isStringValid = (s) => {
	if (s !== undefined && s.length !== 0) {
		return true;
	}
	return false;
};
